import resulter from "@/store/utils/resulter";
import conn from "@/store/utils/connection";
import outletAPI from "@/store/utils/api-route/outletAPI";
import state from "./state"

const actions = {
	async fetchOutletAll({commit}) {
		// if (state.outlet.data !== undefined) {
		// 	if (state.outlet.data.length > 0) {
		// 		return resulter.successResult()
		// 	}
		// }
		try {
			let query = {
				sort_by: state.filter.sortBy,
				order_by: state.filter.orderBy,
				limit: 1000,
				offset: state.pagination.offset,
			}
			if (state.isSearchOutlet) {
				query.key = state.search.key
			}

			const res = await conn.get(outletAPI.list, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setOutlet", res.data)
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},

	async fetchDetailOutlet({commit, rootGetter}, idoutlet){
		if (state.detailOultet.data !== undefined) {
			if (state.detailOultet.data.length > 0) {
				return resulter.successResult()
			}
		}
		try {
			const res = await conn.get(outletAPI.detail, {idoutlet: idoutlet})
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setDetailOutlet", res.data)
				return resulter.successResult("", res.data.data)
			} else {
				return resulter.errorResult(res.data.msg)
			}

		}catch (e) {
			return resulter.errorResult(e)
		}

	}
}

export default actions